import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/runner/work/vc-fullfillment/vc-fullfillment/apps/web/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vc-fullfillment/vc-fullfillment/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"geist\"}");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vc-fullfillment/vc-fullfillment/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vc-fullfillment/vc-fullfillment/node_modules/leaflet/dist/leaflet.css");
